import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { DefectLocationInfo } from '../defect.models';

import './unscanned-building-dialog.component.scss';

@Component({
  selector: 'app-unscanned-building-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  template: `
    <div class="building-dialog-backdrop" (click)="cancel()">
      <div class="building-dialog" (click)="$event.stopPropagation()">
        <div class="building-dialog-header">
          <h4>{{ 'defect_out_of_scanned_area_modal_title' | translate }}</h4>
        </div>

        <div class="building-dialog-search">
          <input
            type="text"
            [(ngModel)]="filterValue"
            (keyup.enter)="applyFilter()"
            placeholder="" />
          <button class="link-btn" (click)="applyFilter()">
            {{ 'defect_out_of_scanned_area_modal_filter_btn' | translate }}
          </button>
        </div>

        <div class="building-dialog-body">
          <ul>
            <li
              *ngFor="let item of filteredList"
              (click)="selectItem(item)"
              [class.selected]="selectedItem === item">
              {{ item.name }} {{ item.description || '' }}
            </li>
          </ul>
        </div>

        <div class="building-dialog-footer">
          <p>
            <span>{{ 'defect_out_of_scanned_area_modal_selected_location_lbl' | translate }}:</span>
            <span class="selected-name">{{ selectedItem?.name || '' }}</span>
          </p>
          <div class="building-dialog-actions">
            <button class="link-btn" (click)="cancel()">
              {{ 'defect_out_of_scanned_area_modal_cancel_btn' | translate }}
            </button>
            <button class="link-btn" (click)="confirm()" [disabled]="!selectedItem">
              {{ 'defect_out_of_scanned_area_modal_continue_btn' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class UnscannedBuildingDialogComponent {
  @Input() buildings: DefectLocationInfo[] = [];
  @Output() buildingSelected = new EventEmitter<DefectLocationInfo | null>();

  filterValue = '';
  selectedItem: DefectLocationInfo | null = null;
  filteredList: DefectLocationInfo[] = [];

  ngOnInit(): void {
    this.filteredList = this.buildings;
  }

  ngOnChanges(): void {
    this.filteredList = this.buildings;
  }

  selectItem(item: DefectLocationInfo): void {
    this.selectedItem = item;
  }

  applyFilter(): void {
    if (!this.filterValue) {
      this.filteredList = this.buildings;
    } else {
      const term = this.filterValue.toLowerCase();
      this.filteredList = this.buildings.filter(
        b => b.name.toLowerCase().indexOf(term) !== -1
      );
    }
  }

  confirm(): void {
    this.buildingSelected.emit(this.selectedItem);
  }

  cancel(): void {
    this.buildingSelected.emit(null);
  }
}
